document.addEventListener('DOMContentLoaded', function () {
    // Use event delegation on a stable parent element (e.g., document or a container)
    document.body.addEventListener('click', function (event) {
      // Check if the clicked element or its parent has the 'desktop-facets__close' class
      const closeButton = event.target.closest('.desktop-facets__close');
      if (closeButton) {
        // Get the id of the target 'details' element
        const detailsId = closeButton.getAttribute('data-target-id');
        if (detailsId) {
          const detailsElement = document.getElementById(detailsId);
          if (detailsElement) {
            // Remove the 'open' attribute
            detailsElement.removeAttribute('open');
          }
        }
      }
    });
 });